import React from "react";
import { motion } from "framer-motion";
import { IndiaMap } from "./IndiaMap";

export const Mission = () => {
    return (
        <section
            id="mission"
            data-testid="mission-section"
            className="relative bg-tip-white text-tip-black py-24 md:py-36"
        >
            <div className="tip-container">
                <div className="grid lg:grid-cols-12 gap-10 items-end mb-16 md:mb-24">
                    <div className="lg:col-span-7">
                        <div className="eyebrow text-black/60 mb-6">
                            01 — Our Mission
                        </div>
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.8 }}
                            className="font-display font-black text-5xl sm:text-6xl md:text-7xl lg:text-[96px] leading-[0.95] tracking-[-0.03em]"
                        >
                            Connecting India
                            <br />
                            Through{" "}
                            <span className="italic">Entertainment.</span>
                        </motion.h2>
                    </div>
                    <div className="lg:col-span-5 lg:pl-10 lg:border-l border-black/10">
                        <p className="text-lg leading-relaxed text-black/75">
                            The India Projekt is a social media-first
                            entertainment company on a mission to put Indian
                            content on the global map.
                        </p>
                        <p className="mt-5 text-base text-black/65 leading-relaxed">
                            We create original digital content that celebrates
                            India&apos;s diversity, sparks meaningful
                            conversations, and showcases the voices, stories,
                            and culture of a new generation. By blending
                            entertainment with authentic storytelling, we aim
                            to build a platform that connects Indians across
                            regions while introducing the richness of India to
                            audiences worldwide.
                        </p>
                    </div>
                </div>

                <IndiaMap />
            </div>
        </section>
    );
};
